export default __webpack_public_path__ + "static/media/logo3.69bd3ad3.png";